import { useTranslation } from 'react-i18next';
import { CurrencyType } from '@tiendanube/common';
import AmountDto from '@tiendanube/common/dist/src/domains/payments/refund/AmountDto';
import { Domain } from '@tiendanube/common/src/enums';
import { DataList, Text } from '@tiendanube/components';
import { CurrencyPrice, Stack } from 'commons/components';

interface Attributes {
  refundedMerchantChargesTotal: AmountDto;
  defaultCurrency: CurrencyType;
}

function OrderRefundedMerchantChargeRow({
  refundedMerchantChargesTotal,
  defaultCurrency,
}: Readonly<Attributes>): JSX.Element {
  const { t } = useTranslation(Domain.ORDERS);
  return (
    <DataList.Row id="refund_merchant_charge_details">
      <DataList.Cell width={70}>
        <Stack spacing="tight">
          <Text>
            {t(`orderSummaryCard.tableAmounts.refundedChargesGeneric`)}
          </Text>
        </Stack>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <CurrencyPrice
          price={Number(refundedMerchantChargesTotal?.value ?? 0)}
          currency={refundedMerchantChargesTotal?.currency ?? defaultCurrency}
          block
          textAlign="right"
        />
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderRefundedMerchantChargeRow;
